<template>
		<div class="home-page-bot">


      <!-- 返回按钮 -->
<!--      <div class="back-btn" @click="back">-->
<!--        <img width="50" src="../../static/images/back.png" />-->
<!--      </div>-->

      <div class="top-nav">
        <div class="nav-left" @click="back">
          <img src="../../static/images/back.png"  class="nav-icon-left" />
        </div>
        <div class="nav-title">{{$t('snapbot')}}</div>
        <div class="nav-right" @click="newChat">
          <img src="../../static/images/new_chat.png"  class="nav-icon" />
        </div>
      </div>
      <!-- 聊天内容容器 -->

      <div class="chat-container chat-bg1" v-if="!messages.length">
        <!-- 欢迎内容 -->
        <div >
          <div class="welcome-box">
            <img style="width: 80%;" src="../../static/images/snapbot-img.png" alt="logo" />
            <h2 style="color: white;font-size: 35px">{{$t('snapbot_hi')}}</h2>
            <p style="color: white;font-size: 20px;margin-top: 10px">{{$t('help_today')}}</p>
          </div>
          <div class="snapbot-block">
            <div class="snapbot-li">
              <img src="../../static/images/bot-img1.png">
              <div class="font">{{$t('snapbotTips1')}}</div>
            </div>
            <div class="snapbot-li">
              <img src="../../static/images/bot-img2.png">
              <div class="font">{{$t('snapbotTips2')}}</div>
            </div>
            <div class="snapbot-li">
              <img src="../../static/images/bot-img3.png">
              <div class="font">{{$t('snapbotTips3')}}</div>
            </div>
            <div class="snapbot-li">
              <img src="../../static/images/bot-img4.png">
              <div class="font">{{$t('snapbotTips4')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-container chat-bg2" v-else>
        <!-- 消息列表 -->
        <div class="message-list">
          <div v-for="(msg, index) in messages" :key="index"
               :class="['message', msg.role]">

            <!-- 如果是机器人，显示头像在左侧 -->
            <img v-if="msg.role === 'assistant'" class="avatar" src="../../static/images/snapbot_icon.png" alt="bot" />

            <div class="bubble">
              <span v-if="msg.loading">{{$t('think_ip')}}</span>
              <span v-else>{{ msg.content }}</span>
            </div>
          </div>
        </div>
          </div>
        <div class="chat-input-box" >
          <input
            v-model="message"
            type="text"
            class="chat-input"
            :placeholder="$t('snapbotInput1')"
            @focus="handleInputFocus"
            @blur="handleInputBlur"
          />
          <button class="send-btn" :class="{ disabled: isBotThinking }" @click="sendMessage">
            <img style="height: 80px;margin-right: 10px" :src="isBotThinking ? '../../static/images/send.png' : '../../static/images/send-active.png'" alt="Send" class="send-icon" />
          </button>
        </div>
      </div>

		</div>
</template>
<script>
import Header from '../components/Header'

import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
      score:0,
      mobile:"",
      isShowHeader:true,
      message: '',
      messages: [],
      suggestions: [],
      isKeyboardVisible: false,
      isBotThinking: false,
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
		this.chaHistory();
	},
  methods: {

		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
			that.$api.get('/api/user/info',null,r =>{
				that.$parent.returnCode(r,function(){
          that.score=r.data.score
          that.mobile=r.data.mobile
        });
			})
		},
    chaHistory(){
      let that =this;
      that.$api.get('/api/index/bot_history',null,r =>{
        that.$parent.returnCode(r,function(){
          setTimeout(() => {
            that.messages.push(...r.data.history);

            // DOM 更新后再滚动到底部
            that.$nextTick(() => {
              const container = document.querySelector('.message-list');
              container.scrollTop = container.scrollHeight;
            });
          }, 1000);
        });
      })
    },
    sendMessage() {
      if (!this.message.trim()) return
      this.messages.push({ content: this.message, role: 'user' });

      this.isBotThinking = true; // 锁住输入

      const loadingMsg = { content: '正在思考中...', role: 'assistant', loading: true };
      // 添加临时 loading 消息
      this.messages.push(loadingMsg);

      this.$nextTick(() => {
        const container = document.querySelector('.message-list');
        container.scrollTop = container.scrollHeight;
      });

      let that =this;
      var params = {message: this.message}
      that.$api.post('/api/index/bot_chat',params,r =>{
        that.$parent.returnCode(r,function(){
          // 替换 loading 消息
          const index = that.messages.findIndex(msg => msg.loading);
          if (index !== -1) {
            that.messages.splice(index, 1, {
              content: r.data.message,
              role: 'assistant'
            });
          }
        });

        this.isBotThinking = false; // 解除锁定

        // DOM 更新完再滚动
        that.$nextTick(() => {
          const container = document.querySelector('.message-list');
          container.scrollTop = container.scrollHeight;
        });


      })
      this.message = '';
    },
    handleInputFocus() {
      this.isKeyboardVisible = true;
      // 滚动到底部确保输入框可见
      setTimeout(() => {
        const container = document.querySelector('.message-list');
        container.scrollTop = container.scrollHeight;
      }, 300);
    },
    handleInputBlur() {
      this.isKeyboardVisible = false;
    },
    newChat(){
      this.messages = [];
      let that =this;
      that.$api.get('/api/index/del_chat',null,r =>{
        that.$parent.returnCode(r,function(){

        });
      })
    },

	}
}
</script>
<style scoped>
.home-page-bot {
  /* height: 100%; */
  /* display: flex; */
  /* overflow: hidden; */
  background: #02051b;
}

.back-btn {
  padding: 20px;
  position: absolute;
  z-index: 1;
}

.chat-container {
  padding: 20px;
  padding-bottom: 140px;
  padding-top: 80px;
  position: relative;
  height:1500px;
  width: 100%;
  overflow: hidden;
}
.message-list{overflow-y: auto;height: calc(100% - 70px);width: 100%}
.input-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #101324;
  border-top: 1px solid #333;
  padding: 10px;
  /* 适配iOS安全区域 */
  padding-bottom: calc(10px + env(safe-area-inset-bottom));
}

.suggestions {
  display: flex;
  gap: 15px;
  padding: 10px;
  color: #6C7080;
}

.chat-input-box {
  display: flex;
  align-items: center;
  background: #202342;
  border-radius: 25px;
  margin-bottom: 15px;
  background: url('../../static/images/text_box.png') no-repeat center center;
  background-size: cover;
  height: 105px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 90%;
  box-shadow: 0 0 60px inset #cb1fa4;
  border-radius: 70px;
  margin: 20px auto;
}

.chat-input {
  flex: 1;
  background: transparent;
  border: none;
  color: white;
  padding: 8px;
  font-size: 25px;
  outline: none;
  margin-left: 25px;
}
input::placeholder{color:#fff !important}
/* 消息气泡样式 */
.message {
  margin: 10px 0;
  display: flex;
}

.message.user {
  justify-content: flex-end;
}

.bubble {
  background: #1b2e6f;
  padding: 12px 20px;
  border-radius: 20px;
  max-width: 70%;
}

.bubble span {
  color: #ffffff;
}

.message.assistant .bubble {
  background: #1b2e6f;
}

/* 适配移动端键盘 */
@media (max-height: 600px) {
  .message-list {
    padding-bottom: 150px; /* 键盘弹出时增加底部空间 */
  }
}

.bubble span {
  display: inline-block;
}

.avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 10px;
  align-self: flex-start;
}

.message.user .avatar {
  margin-left: 10px;
  margin-right: 0;
  order: 2;
}

.send-btn.disabled {
  opacity: 0.5;
  pointer-events: none;
}
.welcome-box {
  position: absolute;
  top: 360px;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
}


.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 10;
  background: rgba(0, 0, 0, 0); /* 半透明背景 */
  backdrop-filter: blur(10px);    /* 毛玻璃效果 */
  color: white;
}

.nav-left,
.nav-right {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-title {
  font-size: 28px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  flex: 1;

}

.nav-icon {
  width: 41px;
  height: 41px;
}

.nav-icon-left {
  width: 30px;
  height: 40px;
}

</style>



// WEBPACK FOOTER //
// src/page/snapbot.vue